var link_viewer_default = {
  "fontElementMap": "_6nUGK",
  "link": "Iv9pg",
  "linkInEditor": "ylS3f",
  "linkInViewer": "_1pAul",
  "toolbarUrlContainer": "zOjsL",
  "toolbarUrl": "-gAof",
  "toolbarUrlAnchor": "_6CWXK"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
